import { ProductPermissions } from '../constants/constants';

export interface Error {
  code: string;
  message: string;
}

export interface APIError {
  traceId: string;
  requestId: string;
  errors: Error[];
}

export interface User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly route: string;
  readonly employeeId: string;
  readonly permissions: ProductPermissions[];
  readonly role: string;
  readonly stores: [];
}

export interface Action<T1 = any, T2 = any> {
  type: T1;
  payload?: T2;
}

export interface IncidentSearchParams {
  statuses?: string[];
  pageNumber?: string;
  pageSize?: string;
  limit?: number;
  searchValue?: string;
  number?: string;
  firstName?: string;
  lastName?: string;
  customerEmail?: string;
}

export interface IncidentRecord {
  contactInfo?: {
    globalCustomerId?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    primaryPhoneNumber?: string;
  };
  status?: string;
  assignTo?: string;
  categoryDescEn?: string;
  subCategoryDescEn?: string;
  actionTypeDescEn?: string;
  shortDescription?: string;
  description?: string;
  rentalReferenceNumber?: string;
  storeNumber?: string;
  createdDate?: string;
  lastModifiedDate?: string;
  resolvedDate?: string;
  businessDuration?: string;
  duration?: string;
  responseTime?: string;
  assignmentGroup?: string;
  assignToName?: string;
  openedByName?: string;
  requestTypeDescEn?: string;
  createdBy?: string;
  resolvedBy?: string;
}

export interface IncidentResponse {
  total: number;
  records: IncidentRecord[];
}

export type FormField =
  | 'ticketNumber'
  | 'channel'
  | 'request_type'
  | 'category'
  | 'firstName'
  | 'sub_category'
  | 'lastName'
  | 'action_type'
  | 'callback'
  | 'agreementnumber'
  | 'alterphonenumb'
  | 'storenumber'
  | 'shortDescription'
  | 'description'
  | 'language'
  | 'medallia'
  | 'assignmentGroup'
  | 'escalatedTo'
  | 'esName'
  | 'role'
  | 'escalationContact'
  | 'comment';

export type ResolutionField = 'rscode' | 'rsnote';
export type ActivityField = 'time' | 'hour' | 'minute' | 'second';
export type TabKey =
  | 'Basic Information'
  | 'Assignment'
  | 'Resolution Information'
  | 'Activity';

export interface Attachments {
  attachmentId?: string;
  attachmentName: string;
  attachmentLocation: string;
}

export interface initialBasicInfoType {
  ticketNumber?: string;
  channel?: string;
  request_type?: string;
  category?: string;
  firstName?: string;
  sub_category?: string;
  lastName?: string;
  action_type?: string;
  callback?: string;
  agreementnumber?: string;
  alterphonenumb?: string;
  storenumber?: string;
  shortDescription?: string;
  description?: string;
  language?: string;
  attachments?: Attachments[];
  comment?: string;
  assignment?: {
    assignmentGroup?: string;
    esName?: string;
    escalationContact?: string;
    role?: string;
    escalatedTo?: string;
  };
}

export interface Incident {
  basicInfo: {
    ticketId?: string;
    ticketNumber?: string;
    channel?: string;
    request_type?: string;
    category?: string;
    firstName?: string;
    sub_category?: string;
    lastName?: string;
    action_type?: string;
    callback?: string;
    agreementnumber?: string;
    alterphonenumb?: string;
    storenumber?: string;
    shortDescription?: string;
    description?: string;
    language?: string;
    attachments?: Attachments[];
    status?: string;
  };
  assignment: {
    escalateToRole?: any;
    assigned?: boolean;
    assignmentGroup?: string;
    esName?: string;
    escalatedTo?: string;
    role?: string;
    escalationContact?: string;
    comment?: string;
  };
  resolution: {
    resolved?: boolean;
    rscode?: string;
    rsnote?: string;
  };
  activity: {
    activities: ActivityItem[];
    ticketNotes: TicketNote[];
    businessDuration: string;
  };
}

export interface ActivityItem {
  activityId: string;
  csmTicketId: string;
  ticketNoteId: string | null;
  statusType: string | null;
  statusDescEn: string | null;
  statusDescEs: string | null;
  assignmentGroup: string | null;
  attachmentId: string | null;
  activityDate: string;
  activityBy: string | null;
  resolvedBy: string | null;
  assignedTo: string | null;
  assignedId: string | null;
}

export interface TicketNote {
  ticketNoteId: string;
  notes: string;
  noteType: string;
  notesBy: string | null;
  notesByRole: string | null;
  notesByName: string | null;
  notesDate: string;
}

export enum ReferenceKeys {
  CATEGORY = 'category',
  SUB_CATEGORY = 'sub_category',
  // PRIORITY = 'priority',
  ACTION_TYPE = 'action_type',
  // SUB_ACTION_TYPE = 'sub_action_type',
  CHANNEL = 'channel',
  LANGUAGE = 'language',
  REQUEST_TYPE = 'request_type',
  // STATUS_TYPE = 'status_type',
  RESOLUTION_TYPE = 'resolution_type',
  // NOTE_TYPE = 'note_type',
  ASSIGNMENT_GROUP = 'assignment_group',
  OPEN_BY = 'openby_list',
}

export enum ReferenceCacheKeys {
  NEW_TICKET = 'references-csm-cache-key',
}

export type Option = {
  label: string;
  value: string;
  id?: string | number;
  pid?: string | number;
};

export interface EscalationOption {
  regionalManager?: any;
  districtManager?: any;
  label: string;
  value: string;
  esName?: string;
  phone_number?: string;
  role?: string;
}
export interface StoreConfigDetail {
  paramValue: string;
  paramKeyName: string;
  paramGroupName?: string;
  paramCategoryName?: string;
  paramKeyId?: string;
  paramHierarchy?: string;
}

export interface StoreConfigByStore {
  storeNumber: string;
  configDetails: StoreConfigDetail[];
}

export interface StoreProfileResponse {
  configDetails: StoreConfigByStore[];
}

export interface StoreConfigsApiResponse {
  storeProfileResponse: StoreProfileResponse;
}

export interface SearchBoxHandle {
  isFilterPanelOpen(): boolean;
  openFilterPanel(): void;
  closeFilterPanel(): void;
}
